import type { OfferJsonType } from '@bb/domain/dist/types';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { OfferForm } from '../../app/offer/OfferEdit/types';

type IRegisterOfferBody = OfferForm;

type IRegisterOfferResponse = OfferJsonType;

const registerOffer = async ({
  listingId,
  offerId,
  offer,
}: {
  listingId: string;
  offerId: string;
  offer: IRegisterOfferBody;
}) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/offer${offerId ? `/${offerId}` : ''}`,
    method: 'post',
    data: offer,
  };

  const { data } = await axios.request<IRegisterOfferResponse>(config);

  return data;
};

export default registerOffer;
